var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',_vm._l((_vm.Diffs),function(dif,i){return _c('span',{key:'meta_list_'+i,class:{ 'text-green': dif.added, 'text-red': dif.removed }},[_vm._v(" "+_vm._s(dif.value)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }